export const SET_SYSTEM_INFO = 'System/Info/set';

export const SET_SYSTEM_TRIAL_NOTICE_VISIBLE = 'System/TrialNotice/visible';

export const SET_SYSTEM_DISABLE_COMM_UPDATER = 'System/DisableCommUpdater/set';

export const SET_SYSTEM_COMM_VERSION = 'System/CommVersion/set';

export const SET_SYSTEM_THEME = 'System/theme/set';

export const SET_SYSTEM_WIDE_SCREEN = 'System/WideScreen/set';
